export enum ViewType {
    AUTHORIZED_USERS = "AUTHORIZED USERS",
    CUSTOMER_AUTHORIZATIONS = "CUSTOMER_AUTHORIZATIONS",
    SENT_APPLICATIONS = "SENT",
    RECEIVED_APPLICATIONS = "RECEIVED",
    ORGANIZATIONS = "ORGANIZATIONS",
}

export function viewTypeToString(viewType: ViewType): string {
    switch(viewType){
        case ViewType.AUTHORIZED_USERS:
            return "authorizedUsers";
        case ViewType.CUSTOMER_AUTHORIZATIONS:
            return "customerAuthorizations";
        case ViewType.SENT_APPLICATIONS:
                return "sentApplications";
        case ViewType.RECEIVED_APPLICATIONS:
                return "receivedApplications";
        case ViewType.ORGANIZATIONS:
                return "organizations";
        default: return '';
    }
}